// src/api/adminAuditsApi.ts
// Adaptador de AUDITORÍAS DE SALUD DE DATOS (super_admin) contra lealify-base (A4).
// Reemplaza el viejo services/auditService.ts (esapi/Firebase). El motor backend
// (lib/dataAudit.js + tabla audit_runs) corre los checks SQL y devuelve los mismos
// shapes que el front consumía. baseApi = cookie httpOnly, cross-tenant.
import { baseApi } from './baseClient';

export type AuditStatus = 'ok' | 'warn' | 'critical' | 'error';

export interface AuditExample {
  label: string;
  ref?: string;
}

export interface AuditCheck {
  key: string;
  label: string;
  status: AuditStatus;
  informational?: boolean;
  metric: string;
  counts?: Record<string, unknown>;
  examples?: AuditExample[];
  hint?: string;
}

export interface AuditTotals {
  businesses?: number;
  users?: number;
  active30d?: number;
}

export interface AuditSnapshot {
  runId: string;
  ranAt: number | null; // ms epoch
  trigger: 'cron' | 'manual';
  durationMs: number;
  health: AuditStatus;
  totals: AuditTotals;
  checks: AuditCheck[];
}

export interface AuditRunSummary {
  runId: string;
  ranAt: number | null;
  health: AuditStatus;
  trigger: 'cron' | 'manual';
  totals: AuditTotals | null;
}

export const adminAuditsApi = {
  // Última corrida persistida (o null si aún no hay).
  fetchLatest: (): Promise<AuditSnapshot | null> =>
    baseApi.get<{ snapshot: AuditSnapshot | null }>('/admin/audits/latest').then((r) => r.snapshot),

  // Resumen del historial (sin el array checks).
  fetchHistory: (n = 30): Promise<AuditRunSummary[]> =>
    baseApi.get<{ runs: AuditRunSummary[] }>(`/admin/audits/history?n=${n}`).then((r) => r.runs),

  // Una corrida por id.
  fetchByRunId: (runId: string): Promise<AuditSnapshot | null> =>
    baseApi
      .get<{ snapshot: AuditSnapshot | null }>(`/admin/audits/${encodeURIComponent(runId)}`)
      .then((r) => r.snapshot),

  // Corre la auditoría manual y devuelve el snapshot recién persistido.
  runNow: (): Promise<AuditSnapshot> =>
    baseApi.post<{ snapshot: AuditSnapshot }>('/admin/audits/run-now').then((r) => r.snapshot),
};

export default adminAuditsApi;
